import { useState, useEffect } from "react";
import { graphql } from "@helpers/graphql";
import { Auth } from "@helpers/context/AuthContext";
interface Supplier {
  calendarUpdatedAt?: string | null;
}

interface SupplierByIdResponse {
  supplierById?: Supplier | null;
}

const useCalendarUpdateAlert = (auth: Auth | undefined) => {
  const [showCalendarAlert, setShowCalendarAlert] = useState(false);

  useEffect(() => {
    if (auth?.id && auth.isSupplier) {
      graphql
        .supplierById({
          id: auth.id,
        })
        .then((results: SupplierByIdResponse) => {
          if (!results.supplierById?.calendarUpdatedAt) {
            setShowCalendarAlert(true);
          } else {
            const today = new Date();
            const calendarUpdatedAt = new Date(
              results.supplierById.calendarUpdatedAt
            );
            const diffTime = today.getTime() - calendarUpdatedAt.getTime();
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            setShowCalendarAlert(diffDays >= 7);
          }
        })
        .catch((error: unknown) => {
          console.error("Error fetching supplier calendar data:", error);
          setShowCalendarAlert(false);
        });
    } else {
      setShowCalendarAlert(false);
    }
  }, [auth]);

  return showCalendarAlert;
};

export default useCalendarUpdateAlert;
